'use client';
import React, { useEffect } from 'react';
import loadBackgroudImages from '../../common/loadBackgroudImages';
import { formatBlogDate } from '../../common/blogStore';

function Header({ blog }) {
  useEffect(() => {
    loadBackgroudImages();
  }, [blog]);

  if (!blog) return null;

  return (
    <header className="header blog-header section-padding pb-0">
      <div className="container mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="caption">
              <div className="sub-title fz-12">
                <a href="/blog-classic">
                  <span>{blog.category}</span>
                </a>
              </div>
              <h1 className="fz-55 mt-30">
                {blog.title}{' '}
                {blog.titleHighlight && (
                  <span className="fw-200">{blog.titleHighlight}</span>
                )}
              </h1>
            </div>
            <div className="info d-flex mt-40 align-items-center">
              <div className="left-info">
                <div className="d-flex align-items-center">
                  <div className="author-info">
                    <div className="d-flex align-items-center">
                      <a href="#0" className="circle-60">
                        <img
                          src="/assets/imgs/blog/author.png"
                          alt=""
                          className="circle-img"
                        />
                      </a>
                      <a href="#0" className="ml-20">
                        <span className="opacity-7">Yazar</span>
                        <h6 className="fz-16">{blog.author || 'Admin'}</h6>
                      </a>
                    </div>
                  </div>
                  <div className="date ml-50">
                    <a href="#0">
                      <span className="opacity-7">Yayın Tarihi</span>
                      <h6 className="fz-16">{formatBlogDate(blog.date)}</h6>
                    </a>
                  </div>
                </div>
              </div>
              <div className="right-info ml-auto">
                <div>
                  <span className="pe-7s-comment fz-18 mr-10"></span>
                  <span className="opacity-7">{blog.comments || 0} Yorum</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="background bg-img mt-80"
        data-background={blog.coverImg || '/assets/imgs/blog/b1.jpg'}
      ></div>
    </header>
  );
}

export default Header;
